import React from "react"
import { Formik } from "formik"
import axios from "axios"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"

const CONTACT_URL = "https://controlgap.com/.netlify/functions/contact-us"

const ContactForm = ({ from }) => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  //6LeKndMUAAAAAAAjfTmkxDNiz8Mr2b7twevGgOBv
  const initialValues = {
    name: "",
    company: "",
    email: "",
    message: "",
    phone: "",
    // reveal: "",
    from,
  }

  const onSubmit = async (values, { setSubmitting }) => {
    const token = await executeRecaptcha("contactUs")
    // console.log("submitting: ")
    // console.log(values)
    values.recaptchaToken = token
    // console.log(values)
    try {
      // send api request to netlify function
      const resp = await axios.post(CONTACT_URL, values)
      console.log(resp.data)
    } catch (e) {
      console.log("Error submitting!")
      console.log(e)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        status,
        submitCount,
        /* and other goodies */
      }) => {
        return submitCount > 0 ? (
          <p>Thanks for reaching out, we will contact you soon!</p>
        ) : (
          <form id="contact-form" name="contact-form" onSubmit={handleSubmit}>
            {/* <div style={{ position: "fixed", right: "-2000px" }}>
              <label tabIndex="-1">
                Reveal
                <input
                  type="text"
                  name="reveal"
                  onChange={handleChange}
                  value={values.reveal}
                />
              </label>
            </div> */}
            <div>
              <label>
                Name
                <input
                  type="text"
                  name="name"
                  required
                  onChange={handleChange}
                  value={values.name}
                />
              </label>
            </div>
            <div>
              <label>
                Company
                <input
                  type="text"
                  name="company"
                  required
                  onChange={handleChange}
                  value={values.company}
                />
              </label>
            </div>
            <div>
              <label>
                Email Address
                <input
                  type="email"
                  name="email"
                  required
                  onChange={handleChange}
                  value={values.email}
                />
              </label>
            </div>
            <div>
              <label>
                Phone Number{" "}
                <input
                  type="tel"
                  name="phone"
                  required
                  onChange={handleChange}
                  value={values.phone}
                />
              </label>
            </div>
            <div style={{ width: "100%", maxWidth: "unset" }}>
              <label>
                Message
                <span style={{ fontWeight: "normal", fontSize: "12px" }}>
                  (optional)
                </span>
                <textarea
                  name="message"
                  onChange={handleChange}
                  value={values.message}
                />
              </label>
              <p style={{ fontSize: "11px", textAlign: "right" }}>
                (This site is protected by reCAPTCHA and the Google{" "}
                <a
                  href="https://policies.google.com/privacy"
                  style={{ color: "inherit" }}
                >
                  Privacy Policy
                </a>{" "}
                and{" "}
                <a
                  href="https://policies.google.com/terms"
                  style={{ color: "inherit" }}
                >
                  Terms of Service
                </a>{" "}
                apply.)
              </p>
            </div>
            {isSubmitting ? (
              "Submitting..."
            ) : (
              <button
                type="submit"
                id="contact-modal-send"
                disabled={isSubmitting}
                className="button-component white-button"
              >
                <span>SEND REQUEST</span>
              </button>
            )}
          </form>
        )
      }}
    </Formik>
  )
}

export default ContactForm
